import React, { useState } from 'react';
import InputFormik from "../../../../../common/components/form/InputFormik";
import ComboBoxFormik from "../../../../../common/components/form/ComboBoxFormik";
import { maskCNPJ, maskCPF, maskPhone } from '../../../../../common/helpers/mask.helpers';

const DataBankFields: React.FC = () => {
  const [keyType, setKeyType] = useState('-');

  const handleKeyTypeChange = (value: unknown) => {
    if (typeof value === 'string') {
      setKeyType(value);
    }
  };

  const getMaskFunction = () => {
    switch (keyType) {
      case "CPF":
        return maskCPF;
      case "Número de Telefone":
        return maskPhone;
      case "CNPJ":
        return maskCNPJ;
      default:
        return undefined;
    }
  };

  return (
    <section>
      <div>
        <ComboBoxFormik
          name="dataBank.typeTransaction"
          label="Tipo de transferência:"
          options={[{ value: "Pix", label: "Pix" }]}
          required={true}
        />
      </div>
      <div>
        <ComboBoxFormik
          name='dataBank.tipoDeChave'
          label='Tipo de chave Pix:'
          options={[
            { value: "-", label: "-" },
            { value: "CPF", label: "CPF" },
            { value: "CNPJ", label: "CNPJ" },
            { value: "Email", label: "Email" },
            { value: "Número de Telefone", label: "Número de Telefone" },
            { value: "Chave Aleatória", label: "Chave Aleatória" },
          ]}
          onChange={handleKeyTypeChange}
          required={true}
        />
      </div>
      <div>
        <InputFormik
          label='Digite a chave do Pix:'
          name='dataBank.chavePix'
          mask={getMaskFunction()} // Aqui passamos a função de máscara
          required={true}
        />
      </div>
    </section>
  );
};

export default DataBankFields;
